import { ProductType } from '@inter-ikea-storageone/range';
import { Entity } from '@inter-ikea-core/core';
import { HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';

const removeOrganizersFromSelectedEntity = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return null;
  }
  const organizers = HierarchyUtils.children(selectedEntity).filter((entity: Entity) =>
    coreApi.entities.isProductType(entity, ProductType.BESTA_SHELF_ORGANIZER)
  );
  coreApi.entities.deleteMultiple(organizers);
};

export default removeOrganizersFromSelectedEntity;
